import type { DeviceStatus } from "@meridian-mdm/shared";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const statusConfig: Record<DeviceStatus, { label: string; className: string }> = {
  pending: {
    label: "Pending",
    className: "border-gray-300 bg-gray-100 text-gray-700",
  },
  triggering: {
    label: "Triggering",
    className: "border-blue-300 bg-blue-100 text-blue-700",
  },
  triggered: {
    label: "Triggered",
    className: "border-amber-300 bg-amber-100 text-amber-700",
  },
  confirmed: {
    label: "Confirmed",
    className: "border-green-300 bg-green-100 text-green-700",
  },
  trigger_failed: {
    label: "Failed",
    className: "border-red-300 bg-red-100 text-red-700",
  },
  timeout: {
    label: "Timeout",
    className: "border-orange-300 bg-orange-100 text-orange-700",
  },
  unenrolled: {
    label: "Unenrolled",
    className: "border-slate-300 bg-slate-100 text-slate-700",
  },
  up_to_date: {
    label: "Up to Date",
    className: "border-emerald-300 bg-emerald-100 text-emerald-700",
  },
  not_installed: {
    label: "Not Installed",
    className: "border-stone-300 bg-stone-100 text-stone-500",
  },
  skipped: {
    label: "Skipped",
    className: "border-gray-300 bg-gray-100 text-gray-500",
  },
  requesting_management: {
    label: "Requesting Mgmt",
    className: "border-indigo-300 bg-indigo-100 text-indigo-700",
  },
  management_failed: {
    label: "Management Failed",
    className: "border-rose-300 bg-rose-100 text-rose-700",
  },
  reinstalling: {
    label: "Reinstalling",
    className: "border-violet-300 bg-violet-100 text-violet-700",
  },
  reinstall_failed: {
    label: "Reinstall Failed",
    className: "border-rose-300 bg-rose-100 text-rose-700",
  },
};

export function StatusBadge({ status }: { status: DeviceStatus }) {
  const config = statusConfig[status];
  return (
    <Badge variant="outline" className={cn("font-medium", config.className)}>
      {config.label}
    </Badge>
  );
}
